import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@custom-components';
import { adminPropertyShape } from '../helperFunctions';
import AdminPropertyTable from './AdminPropertyTable';

import PaginatedList from '../PaginatedList';

const adminPropertiesViewFilters = [
  {
    id: 'ALL_PROPERTIES_VIEW',
    label: 'All Properties',
    filterFn: () => true
  },
  // status: Draft, Pending, Approved, Rejected, Archived, Published
  {
    id: 'DRAFT_PROPERTIES',
    label: 'Status: Draft',
    filterFn: () => true
  },
  {
    id: 'APPROVED_PROPERTIES',
    label: 'Status: Approved',
    filterFn: () => true
  },
  {
    id: 'PUBLISHED_PROPERTIES',
    label: 'Status: Published',
    filterFn: () => true
  },
  {
    id: 'ARCHIVED_PROPERTIES',
    label: 'Status: Archived',
    filterFn: () => true
  }
];

const adminPropertiesSortFilters = [
  {
    id: 'PROPERTY_NAME_SORT',
    label: 'Property Name (asc)',
    sortFn: () => 0
  },
  {
    id: 'PROPERTY_NAME_SORT_DESC',
    label: 'Property Name (desc)',
    sortFn: () => 0
  },
  {
    id: 'PROPERTY_UPDATE_SORT',
    label: 'Recently Updated (desc)',
    sortFn: () => 0
  },
  {
    id: 'PROPERTY_UPDATE_SORT_DESC',
    label: 'Recently Updated',
    sortFn: () => 0
  },
  {
    id: 'PROPERTY_LOCATION_SORT',
    label: 'City (asc)',
    sortFn: () => 0
  },
  {
    id: 'PROPERTY_LOCATION_SORT_DESC',
    label: 'City (desc)',
    sortFn: () => 0
  }
];

function PaginatedAdminPropertyList(props) {
  const { allProperties, totalItems, loading, error, orgId, openTaxes, openEditor, paginationFunctionsProps } = props;
  const { handleChangeSearchString, handleChangeFilter, handleChangeSort } = paginationFunctionsProps;
  return (
    <Grid.ScreenClassRender
      render={(screenClass) => (
        <PaginatedList
          data={allProperties}
          totalItems={totalItems}
          loading={loading}
          error={error}
          viewFilters={adminPropertiesViewFilters}
          sortFilters={adminPropertiesSortFilters}
          onSearchChange={handleChangeSearchString}
          onFilterChange={handleChangeFilter}
          onSortChange={handleChangeSort}
          screenClass={screenClass}
          tableComponent={AdminPropertyTable}
          helpText="Search by property name, location or status"
          noDataObj={{
            message: 'There are no properties for that search, or no properties have been created',
            title: 'No Properties'
          }}
          searchBy={['name', 'city', 'region', 'status']}
          listComponentProps={{ defaultView: 'tableView', initialSortFilterId: 'PROPERTY_UPDATE_SORT_DESC' }}
          paginationFunctionsProps={paginationFunctionsProps}
          otherComponentProps={{ orgId, openTaxes, openEditor }}
        />
      )}
    />
  );
}

PaginatedAdminPropertyList.propTypes = {
  allProperties: PropTypes.arrayOf(adminPropertyShape).isRequired,
  totalItems: PropTypes.number.isRequired,
  paginationFunctionsProps: PropTypes.shape({
    handleChangeSearchString: PropTypes.func.isRequired,
    handleChangeFilter: PropTypes.func.isRequired,
    handleChangeSort: PropTypes.func.isRequired
  }).isRequired,
  loading: PropTypes.bool,
  error: PropTypes.shape({}),
  orgId: PropTypes.string,
  openTaxes: PropTypes.func.isRequired,
  openEditor: PropTypes.func.isRequired
};

PaginatedAdminPropertyList.defaultProps = {
  loading: true,
  error: null,
  orgId: ''
};

export default PaginatedAdminPropertyList;
